import { CookingPot } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { Link } from '@/i18n/routing';
import { cn } from '@/lib/utils';

import { Button } from '../ui/button';

interface SendRecipeButtonProps {
    isActivePath: (href: string) => boolean;
}

export const SendRecipeButton = ({ isActivePath }: SendRecipeButtonProps) => {
    const t = useTranslations();

    return (
        <Link href='/recipes/send'>
            <Button
                asChild
                className={cn(
                    'bg-transparent rounded-none justify-center items-center h-[48px] hover:bg-transparent lg:hover:bg-white-alpha-10 border-white border-2',
                    'text-white flex items-center gap-2',
                    isActivePath('/recipes/send') && 'text-yellow border-yellow ',
                )}
            >
                <div className='flex items-center gap-2'>
                    <CookingPot width={16} height={16} />
                    <span className='text-sm font-medium tracking-wide'>{t('send-recipe')}</span>
                </div>
            </Button>
        </Link>
    );
};
